import { render } from "./i18n-flags.vue?vue&type=template&id=58450098&ts=true"
import script from "./i18n-flags.vue?vue&type=script&lang=ts"
export * from "./i18n-flags.vue?vue&type=script&lang=ts"

import "./i18n-flags.vue?vue&type=style&index=0&id=58450098&lang=css"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/shared/i18n/i18n-flags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58450098"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58450098', __exports__)) {
    api.reload('58450098', __exports__)
  }
  
  module.hot.accept("./i18n-flags.vue?vue&type=template&id=58450098&ts=true", () => {
    api.rerender('58450098', render)
  })

}


export default __exports__